import { ROSTER } from '../data/roster.js';
import { FAQS } from '../data/faqs.js';
import { MATCHES } from '../data/matches.js';
import { APPLICATIONS } from '../data/applications.js';
import { SPONSOR_INQUIRIES } from '../data/sponsor-inquiries.js';

const KEYS = {
  roster:            { ls: 'ggdad.roster',            fallback: ROSTER },
  faq:               { ls: 'ggdad.faq',               fallback: FAQS },
  matches:           { ls: 'ggdad.matches',           fallback: MATCHES },
  applications:      { ls: 'ggdad.applications',      fallback: APPLICATIONS },
  sponsor_inquiries: { ls: 'ggdad.sponsor_inquiries', fallback: SPONSOR_INQUIRIES }
};

function entry(key) {
  const e = KEYS[key];
  if (!e) throw new Error(`unknown store key: ${key}`);
  return e;
}

export function read(key) {
  const e = entry(key);
  const raw = localStorage.getItem(e.ls);
  if (raw === null) return e.fallback;
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : e.fallback;
  } catch {
    return e.fallback;
  }
}

export const STORE_KEYS = Object.keys(KEYS);

export function write(key, value) {
  const e = entry(key);
  if (!Array.isArray(value)) throw new Error(`store.write requires an array, got ${typeof value}`);
  localStorage.setItem(e.ls, JSON.stringify(value));
}

export function clear(key) {
  const e = entry(key);
  localStorage.removeItem(e.ls);
}

export function exportAll() {
  return {
    version: 1,
    exportedAt: new Date().toISOString(),
    roster:            read('roster'),
    faq:               read('faq'),
    matches:           read('matches'),
    applications:      read('applications'),
    sponsor_inquiries: read('sponsor_inquiries')
  };
}

export function importAll(payload) {
  if (!payload || payload.version !== 1) throw new Error('importAll: missing or unsupported version');
  for (const k of STORE_KEYS) {
    if (!Array.isArray(payload[k])) throw new Error(`importAll: payload.${k} must be an array`);
  }
  for (const k of STORE_KEYS) write(k, payload[k]);
}
